// extracted by mini-css-extract-plugin
export var actionButton = "_g4-0";
export var fileInput = "_g4-2";
export var paperclip = "_g4-1";